<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { useAppRouting } from '@/composables/useAppRouting'

withDefaults(defineProps<{
  isWithBackground?: boolean
}>(), {
  isWithBackground: false,
})

const { getParentRoute } = useAppRouting()
const parentRoute = getParentRoute()
</script>

<template>
  <header :class="['focus-header', { 'with-background': isWithBackground }]">
    <slot />
    <CommonButton
      v-if="parentRoute"
      :to="parentRoute"
      aria-label="Tilbake"
      shape="icon"
      class="button"
    >
      <FontAwesomeIcon :icon="faXmark" />
    </CommonButton>
  </header>
</template>

<style scoped lang="scss">
  .focus-header {
    :deep(.vgs-button) {
      --btn-bgcolor: var(--color-pair-background-color, var(--color-yellow-10));
    }

    display: flex;
    justify-content: flex-end;
    position: fixed;
    top: 0;
    right: 0;
    padding: 16px 32px;
    width: 100%;
    z-index: 999;

    @include vgs-media-mobile-and-tablet {
      color: var(--color-red-50);
      padding: 8px 24px;

      &.with-background {
        background-color: var(--app-theme-background-color);
        box-shadow: 0 4px 3px 0 #00000040;
      }
    }
  }

  .button {
    position: absolute;
  }
</style>
